<template>
  <div>
      <el-button type="primary" @click="exportExl" :loading="loading">导出</el-button>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { exportApi } from "@/api/module/export/export";

export default {
  name: "ExportStudyClassBtn",
  
  mixins: [BaseVue],
  
  props: {
    // api 默认地址
    serverUrl: {
      type: String,
      required: true
    },
    // 导出文件名
    filename: {
      type: String,
      required: true
    }
  },
  
  data() {
    return {
      data: {},
      loading: false
    };
  },
  
  methods: {
    init() {
      // 初始化逻辑
    },
    
    updateParams(pkey, pval) {
      // 使用Vue.set或this.$set确保响应式
      this.$set(this.data, pkey, pval);
      console.log("updateParams", this.data);
    },
    
    exportExl() {
      this.loading = true;
      
      // 暂未提供
      // this.$message.info("功能即将上线");
      // this.loading = false;
      
      exportApi(this.data, this.serverUrl)
        .then((res) => {
          let data = res.data;
          let url = window.URL.createObjectURL(new Blob([data]));
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', this.filename);
          document.body.appendChild(link);
          link.click();
        })
        .catch((e) => {
          this.$message.error("服务器内部错误!");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  
  created() {
    // 组件创建时的逻辑
  }
};
</script>


<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>